//@flow
import { takeEvery, put, call, select } from 'redux-saga/effects';
import { tripica } from '../../api';
import { setLoading } from '../LoadingStatus/actions';
import type { WalletActionType } from './actions';
import type { IOEffect } from 'redux-saga/effects';
import { customerOuidSelector, customerTaxExemptionsSelector } from '../Customer/selectors';
import { currentSubscriptionBillingAccountOuidSelector, currentSubscriptionOuidSelector } from '../Dashboard/reducer';
import { triggerPaymentProductOrderPolling } from '../PollingOrder';
import Navigation from '../../lib/navigation';
import { CommonActions } from '@react-navigation/native';
import WizzeeLog from '../../lib/wizzeeLog';

export function* addMoney(action: WalletActionType): Generator<*, *, *> {
  yield put(setLoading('addMoney', true));

  try {
    const customerOuid = yield select(customerOuidSelector);
    let billingAccountOuid;
    let response = null;

    const amountInCents = parseFloat(action.payload.amount.replace(',', '.')) * 100;
    const fixedAmount = Math.floor(parseFloat(amountInCents.toFixed(1)));

    switch (action.payload.type) {
      case 'WALLET':
        response = yield call([tripica, 'creditWallet'], customerOuid, 0, fixedAmount);
        break;
      case 'PREMIUM':
        billingAccountOuid = yield select(currentSubscriptionBillingAccountOuidSelector);
        const subscriptionOuid = yield select(currentSubscriptionOuidSelector);
        const customerTaxExemptions = yield select(customerTaxExemptionsSelector);
        response = yield call(
          [tripica, 'creditPremiumUsages'],
          customerOuid,
          billingAccountOuid,
          subscriptionOuid,
          fixedAmount,
          customerTaxExemptions
        );
        break;
      default:
        throw new Error('Trying to add money to not existing type');
    }

    if (!response || !response.errorCodeList) {
      throw new Error('No response or error code list');
    }

    if (response && response.status === 'VALIDATED') {
      const productOrder = yield call(
        triggerPaymentProductOrderPolling,
        'ADD_MONEY',
        response.uuid,
        action.payload.errorMapForOrderState,
        true,
        false
      );

      if (productOrder.state === 'COMPLETED') {
        yield call(Navigation.dispatch, CommonActions.navigate({ name: 'PaymentSuccess' }));
      } else if (productOrder.state === 'IN_PROGRESS') {
        yield call(Navigation.dispatch, CommonActions.navigate({ name: 'PaymentInProgress' }));
      } else {
        throw new Error('product order fetch failed');
      }
    } else if (response.errorCodeList.includes('RENEWAL_IN_PROGRESS')) {
      yield call(Navigation.dispatch, CommonActions.navigate({ name: 'PaymentRenewalInProgress' }));
    } else {
      throw new Error(response.errorCodeList.join(','));
    }
  } catch (e) {
    WizzeeLog.warn('[saga] addMoney', e);
    yield call(Navigation.dispatch, CommonActions.navigate({ name: 'PaymentFailure' }));
  } finally {
    yield put(setLoading('addMoney', false));
  }
}

export default function* walletSaga(): Generator<IOEffect, void, any> {
  yield takeEvery('ADD_MONEY', addMoney);
}
